import { connect } from "react-redux";
import RetailerCouponsInventoryView from "./RetailerCouponsInventory_View";
import {RetailerCouponsInventoryServer} from "./server"
import {RetailerCouponsInventoryActions} from './RetailerCouponsInventoryConstants'
const mapStateToProps = state => {
    console.log(state)
    return {
        RetailerCouponsInventory_GET_status:state.RetailerCouponsInventoryReducer.RetailerCouponsInventory_Status,
        RetailerCouponsInventory:state.RetailerCouponsInventoryReducer.RetailerCouponsInventoryDetails,
        RetailerCouponsInventory_Error:state.RetailerCouponsInventoryReducer.RetailerCouponsInventory_Error,
        RetailerCouponsInventoryCount:state.RetailerCouponsInventoryReducer.RetailerCouponsInventoryCount
       // RetailerCouponsInventoryIndex:state.RetailerCouponsInventoryReducer.RetailerCouponsInventoryIndex
    };
};
const mapDispatchToProps = dispatch => {
    return {
        
        getRetailerCouponsInventory: (data) => {

           dispatch( RetailerCouponsInventoryServer.getRetailerCouponsInventory(data) )
        },
        getFilteredCouponsInventory: (data) => {
            dispatch( RetailerCouponsInventoryServer.getFilteredCouponsInventory(data) )
         },
        resetReducerState:()=>{
            dispatch({type:RetailerCouponsInventoryActions.RetailerCouponsInventory_GET.NEW})
        }
    }
};
const RetailerCouponsInventoryContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RetailerCouponsInventoryView)

export default RetailerCouponsInventoryContainer;